import { render, staticRenderFns } from "./NoteChip.vue?vue&type=template&id=ffb30cee"
import script from "./NoteChip.vue?vue&type=script&lang=js"
export * from "./NoteChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports